import { render, staticRenderFns } from "./DocumentsNoMatch.vue?vue&type=template&id=2ded4cd5&"
import script from "./DocumentsNoMatch.vue?vue&type=script&lang=js&"
export * from "./DocumentsNoMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports